export default __webpack_public_path__ + "static/media/fl7.ab0fbd4c.png";